import React from 'react';
import {ToggleGroup} from '../../components/togglegroup/index';
import {pieChartState, FILL_PATTERN_TOGGLE_EVENT} from '../../schoolTypes/piechart';
import { connect } from 'react-redux';

class Filters extends React.Component{
	constructor(props) {
		super();

		this.state = {
			enabled: pieChartState.fillPaternActive
		}

		this.fillPatternChangeHandler = this.fillPatternChangeHandler.bind(this);
	}
	fillPatternChangeHandler() {
		this.setState({enabled: pieChartState.fillPaternActive}); 
	}
	componentDidMount() {

    //	pieChartState.on(FILL_PATTERN_TOGGLE_EVENT, this.fillPatternChangeHandler);
	}
	componentWillUnmount() {

    //	pieChartState.removeListener(FILL_PATTERN_TOGGLE_EVENT, this.fillPatternChangeHandler);
	}
	toggleHandler() {

	    if(pieChartState.fillPaternActive) {

	      pieChartState.fillPatern(false);

	    } else {
	    	
	      pieChartState.fillPatern(true);
	    }
	    
	    this.setState({enabled: pieChartState.fillPaternActive});
	}
	render() {

		return (<ToggleGroup
			clickItemHandler={this.toggleHandler.bind(this)} 
			menuItems={[
				{id: 1, name: 'Šrafējums', active: this.state.enabled}
			]}
			name="Skolas pēc mācību valodas"
		/>);
	}
}

const mapDispatchToPropsRes = (dispatch) => {

  return {
    clickItem: () => {
      
    }
  }
}

const mapStateToPropsRes = (state) => {

  return {
  
  }
}

const MenuSection = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(Filters);

export default MenuSection;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/filters/language/container.js